import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, MapPin } from 'lucide-react';
import { markets } from '../../data/mock';

export const MarketsSection = () => {
  return (
    <section className="py-24 bg-navy-900 relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 1200 600" fill="none">
          <circle cx="600" cy="300" r="250" stroke="currentColor" strokeWidth="1" className="text-teal-400" />
          <circle cx="600" cy="300" r="350" stroke="currentColor" strokeWidth="1" className="text-teal-400" />
          <circle cx="600" cy="300" r="450" stroke="currentColor" strokeWidth="1" className="text-teal-400" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-teal-500/20 text-teal-400 text-sm font-medium mb-4">
            Global Reach
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Markets We Trade With
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Strategic presence across key international markets, with deep expertise 
            in trade regulations and local business practices for imports and exports.
          </p>
        </div>

        {/* Markets Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {markets.map((market) => (
            <div
              key={market.id}
              className="group p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 hover:border-teal-500/30 transition-all duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-xl font-semibold text-white group-hover:text-teal-400 transition-colors">
                    {market.name}
                  </h3>
                  <span className="text-sm text-slate-400">{market.region}</span>
                </div>
                <div className="p-2 rounded-lg bg-teal-500/20">
                  <MapPin className="h-5 w-5 text-teal-400" />
                </div>
              </div>

              <p className="text-slate-300 text-sm mb-4 leading-relaxed">
                {market.description}
              </p>

              {/* Trade Focus */}
              <div className="flex flex-wrap gap-2">
                {market.tradeFocus.slice(0, 3).map((focus) => (
                  <span
                    key={focus}
                    className="px-2 py-1 bg-white/5 text-slate-300 text-xs rounded-md"
                  >
                    {focus}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link to="/markets">
            <Button
              size="lg"
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 rounded-xl"
            >
              Explore All Markets
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
